import { render, staticRenderFns } from "./RichText1.vue?vue&type=template&id=0750210c"
import script from "./RichText1.vue?vue&type=script&lang=js"
export * from "./RichText1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports